/**
 * Parses a date string (YYYY-MM-DD) and returns a Date object in local timezone.
 * This prevents the common timezone issue where new Date("YYYY-MM-DD") 
 * interprets the date as UTC midnight, causing a day shift in timezones behind UTC.
 * 
 * @param dateString - Date string in YYYY-MM-DD format
 * @returns Date object representing the date in local timezone
 */
export function parseLocalDate(dateString: string): Date {
  if (!dateString) return new Date();
  
  // Append time to force local timezone interpretation
  return new Date(dateString + 'T00:00:00');
}